import { create } from "zustand";

import { IsFeedbackSent } from "./IsFeedbackSent";

export const useIsFeedbackSent = create<IsFeedbackSent>((set) => ({
  isFeedbackSent: false,
  markFeedbackAsSent: () => set(() => ({ isFeedbackSent: true })),
}));
